module.exports = __webpack_public_path__ + "img/wechat_qrcode@2x.e4ca1969.png";